<template>
  <div class="dialog page-dialog">
    <div class="container">
      <div class="dialog-header">{{ ts('Payment Result')['Payment Result'] }}</div>
      <div class="dialog-content">
        <div class="pay-status">
          <div class="icon-svg">
            <img src="../../assets/images/table-error.svg" width="180" />
          </div>
          <div class="title">{{ ts('Payment unsuccessful !')['Payment unsuccessful !'] }}</div>
          <p>{{ ts('Please try again or go back to the previous page and select another payment method')['Please try again or go back to the previous page and select another payment method'] }}</p>
        </div>
        <div class="dialog-footer">
          <el-button type="primary" class="btn btn-theme" @click="$router.push('/user')">{{ ts('MY ACCOUNT')['MY ACCOUNT'] }}</el-button>
          <el-button type="primary" class="btn btn-theme" @click="tryAgain">{{ ts('TRY AGAIN')['TRY AGAIN'] }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LanguagePackage } from '@/mixins/LanguagePackage'
export default {
  name: 'PayFail',
  mixins: [LanguagePackage],
  data() {
    return {}
  },
  created() {},
  methods: {
    // 再次支付
    tryAgain() {
      const { id, platForm, hotelId, type, orderType } = this.$route.query
      if (type == 'stayExtend') {
        // 续房支付
        this.$store.dispatch('createExtendStayPayment', {
          orderId: id,
          platForm, // Stripe , Paypay
        })
      } else {
        let data = {
          groupId: id, // 组合订单Id
          hotelId,
          platForm, // Stripe , Paypay
        }
        if (orderType && orderType != 'undefined') {
          data.orderType = orderType
        }
        this.$store.dispatch('createPayment', data)
      }
    },
  },
}
</script>

<style scoped lang="sass"></style>
